<div class="flex-1 flex flex-col overflow-hidden">
  <app-map
    [type]="'manager'"
    class="flex-grow overflow-hidden"
    [fields]="fields"
    [isUpdateZoomLevel]="isUpdateZoomLevel"
    [etHistoryLoading]="etHistoryLoading"
    [resolvedEtDates]="resolvedEtDates"
    [failedEtDates]="failedEtDates"
    [initialSymbology]="'et'"
    [clients]="clients"
    [(selectedClientId)]="clientId"
    (featureProperties)="selectUpdateModalShow($event)"
    (fieldOperatedEvent)="onCreateUpdateCropRecords()"
    (etDateRequested)="loadEtDate($event)"
  />
</div>

<app-field-selection-update
  (fieldOperatedEvent)="onCreateUpdateCropRecords($event)"
  [id]="createdOrUpdateProperties?.id"
  [client_name]="createdOrUpdateProperties?.client_name"
  [owner]="createdOrUpdateProperties?.owner"
  [crops]="crops"
  [cropsNoFallow]="cropsNoFallow"
  [isManager]="true"
/>

<app-field-view-manager
  [id]="properties?.id"
  [properties]="properties?.claimed_details"
></app-field-view-manager>
